export const getSymbolId = (name: string) => `icon-${name}`;
